var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 566,
    viewBox: "0 0 448 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41936 398.994L427.791 130.485L383.671 102.684L43.8741 318.739L44.1707 271.843L347.64 79.9798L302.782 51.7148L43.0272 216.548L43.6347 170.918L266.751 29.0107L221.159 0.282715L0.166656 138.177L1.41936 398.994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.976 565.717L181.31 537.062L403.676 396.461V350.789L143.562 513.779L18.8396 433.179L447.984 161.828V216.456L104.998 433.179L143.562 458.254L447.984 264.816V425.119L223.976 565.717Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.3b76c27c606342e02d52bb42371dba1d.svg";
export { ForwardRef as ReactComponent };